export default {"src":"/newStatic/_next/static/media/pattern-8.7f0bf0a5.svg","height":140,"width":1280};